// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";

import baseApi from "@/lib/redux/api/baseApi";
import "@/lib/redux/api/googleIntegrationApi";
import { apiErrorMiddleware } from "@/lib/redux/middleware";
import formReducer from "@/lib/redux/slices/formSlice";
import signoutReducer from "@/lib/redux/slices/signoutSlice";
import locationReducer from "@/lib/redux/slices/locationSlice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    form: formReducer,
    signout: signoutReducer,
    location: locationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(baseApi.middleware)
      .concat(apiErrorMiddleware),
});
